var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.852,
    height: 32,
    viewBox: "0 0 147.852 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.718,0V5.668h9.956V32h7.054V5.67h9.956V0Z",
    transform: "translate(-83.948 2)",
    fill: "#00acee"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.436,30.036a13.143,13.143,0,0,1-5.3-5.586,18.4,18.4,0,0,1-1.862-8.5A18.132,18.132,0,0,1,222.135,7.5a13.208,13.208,0,0,1,5.3-5.542,17.684,17.684,0,0,1,16.143,0A13.116,13.116,0,0,1,248.836,7.5a18.324,18.324,0,0,1,1.84,8.455,18.6,18.6,0,0,1-1.84,8.5,13.053,13.053,0,0,1-5.258,5.586,17.684,17.684,0,0,1-16.143,0m14.237-6.155q2.212-2.76,2.212-7.929t-2.212-7.886a8.332,8.332,0,0,0-12.31,0q-2.213,2.716-2.213,7.886,0,5.213,2.213,7.951a8.265,8.265,0,0,0,12.31-.022Z",
    transform: "translate(-153.177 -0.001)",
    fill: "#00acee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,0V32h-6.2V14.515L359.526,32h-4.536L347.574,14.74V32h-6.157V0h5.573l10.337,23.595L367.574,0Z",
    transform: "translate(-237.424 0)",
    fill: "#00acee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.273,17l-1.96-3.492L7.945,32H0L18.315,0l9.8,17Z",
    transform: "translate(0 0)",
    fill: "#00acee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.41,66.1h7.873l6.841,11.866H79.075Z",
    transform: "translate(-50.354 -45.964)",
    fill: "#00acee"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.605 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V.556H1.22V3.744h.685V.556H3.13V0Z",
    transform: "translate(0 0)",
    fill: "#009bdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.533,0,5.255,2.928,3.966,0H3.43V3.744h.6v-2.3l1,2.3h.447l1-2.324V3.744h.6V0Z",
    transform: "translate(0.178 0)",
    fill: "#009bdb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtom);
export default __webpack_public_path__ + "static/media/atom.ea2c317ef4da2554e6e89b9f8dcf10d2.svg";
export { ForwardRef as ReactComponent };